const rmmDataViewer = {
    templateUrl: '/modules/configurationManagement/rmm-data-viewer/rmm-data-viewer.html',
    controller: 'RMMDataViewerController',
};

angular
    .module('configuration-management.module')
    .component('rmmDataViewer', rmmDataViewer)
    .config(function ($stateProvider) {
        $stateProvider.state('train.dataviewer', {
            url: '/dataviewer',
            views: {
                'traintab@train': 'rmmDataViewer',
            },
            resolve: {
                auth: function (userService, $state, eventService) {
                    return userService
                        .resolve(['VIEW_RMM'])
                        .then(() => {
                        })
                        .catch(() => {
                            eventService.trigger('userservice:unauthorized');
                            $state.go('train');
                        });
                },
            },
        });
    });